<script lang="ts" setup>
import { Subscription } from "rxjs";
import { Checklist } from "types/Checklist";

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
  existingChecklistId: {
    type: String,
  },
});

const emit = defineEmits(["close"]);

const loadingChecklists = ref(true);
const selectedChecklistId = ref<string | undefined>(props.existingChecklistId);

const changingChecklist = ref(false);

const changeChecklist = async () => {
  const selectedChecklist = checklists.value.find(
    (checklist: Checklist) => checklist.id == selectedChecklistId.value
  );

  if (selectedChecklist == undefined) {
    useBaseToast("Oops! You did not choose a checklist.", "error");
    return;
  }

  changingChecklist.value = true;

  await useApplyChecklistToDocuments().applyChecklistToDocumentNow(
    selectedChecklist.id!,
    selectedChecklist.path ?? "/checklists",
    props.documentId
  );

  useDocumentChecklistStore(props.documentId).initialize();

  window.location.reload();
};

const subscription = ref<Subscription | undefined>();

const userChecklistStore = useUserChecklistsStore();
const { checklists } = storeToRefs(userChecklistStore);

onMounted(() => {
  // loadingChecklists.value = true;
  // subscription.value = useUserChecklists()
  //   .streamUserChecklists()
  //   .subscribe((checklists: Checklists) => {
  //     userChecklists.value = checklists;
  //     loadingChecklists.value = false;
  //   });
  loadingChecklists.value = false;
});

onUnmounted(() => {
  subscription.value?.unsubscribe();
});
</script>

<template>
  <div class="w-[500px] p-4">
    <div v-auto-animate>
      <h2 class="text-h5 font-bold mb-4 border-b py-2">Choose Checklist</h2>
      <ChecklistsSelect v-model="selectedChecklistId" :prevent-default="true" />

      <BaseButton
        :show-spinner="changingChecklist"
        class="mt-4"
        @click="changeChecklist"
      >
        Save
      </BaseButton>
      <div v-if="changingChecklist" class="mt-2 text-center">
        Your checklist is being updated. This could take a minute. Do not close
        the dialog window.
      </div>
    </div>
  </div>
</template>

<style>
.change-checklist-modal {
  z-index: 9999 !important;
}
.change-checklist-modal-content {
  display: flex;
  flex-direction: column;

  width: 600px;

  margin: auto;
  @apply rounded;
  margin-top: 64px;
}
</style>
